import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../utils/axiosConfig';
import { Button, Container, Typography } from '@mui/material';
import ParticipantsList from './ParticipantsList';
import ProjectDialog from './ProjectDialog';

const ProjectView = () => {
  let { projectId } = useParams();
  const [projectName, setProjectName] = useState('');
  const [interviews, setInterviews] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const fetchInterviews = useCallback(async () => {
    try {
      const response = await axios.get(`/api/projects/${projectId}/interviews`);
      setInterviews(response.data);
    } catch (error) {
      console.error('Failed to fetch interviews:', error);
    }
  }, [projectId]);  // Dependency on projectId

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await axios.get(`/api/projects/${projectId}`);
        setProjectName(response.data.project_name);
        fetchInterviews();  // Fetch interviews when project data is fetched
      } catch (error) {
        console.error('Failed to fetch project:', error);
      }
    };
    fetchProject();
  }, [projectId, fetchInterviews]);  // Include fetchInterviews in the dependency array

  const handleParticipantsUpdate = () => {
    fetchInterviews();
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <Container maxWidth="md">
        <Typography variant="h4" gutterBottom>
        {projectName || projectId}
        </Typography>
      <Button variant="contained" color="secondary" onClick={handleDialogOpen}>
        Edit Guidelines
      </Button>
      <ParticipantsList projectId={projectId} participants={interviews} onParticipantsUpdate={handleParticipantsUpdate} />
      <ProjectDialog open={dialogOpen} onClose={handleDialogClose} projectId={projectId} isNewProject={false} />
    </Container>
  );
}

export default ProjectView;